import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import AuthLayout from "layouts/Auth/Auth.js";
import AdminLayout from "layouts/Admin/Admin.js";
import ProducerPortal from "views/producers/ProducerPortal";
import QuickApp from "views/quick-app/QuickApp";
// import RTLLayout from "layouts/RTL/RTL.js";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/auth/*" element={<AuthLayout />} />
        <Route path="/produttore/:token" element={<ProducerPortal />} />
        <Route path="/app" element={<QuickApp />} />
        <Route path="/*" element={<AdminLayout />} />
        {/* <Route path="/dashboard" element={<AdminLayout />} /> */}
        {/* <Route path="/rtl/*" element={<RTLLayout />} /> */}
        {/* <Route path="*" element={<Navigate to="/dashboard" replace />} /> */}
      </Routes>
    </BrowserRouter>
  );
}
